import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Text, useStyleConfig, Button, Image} from '@chakra-ui/react'
import Link from '@salesforce/retail-react-app/app/components/link'
import {productUrlBuilder} from '../../../utils/url'
/* import CartItemVariantImage from '../../item-variant/item-image'
import CartItemVariantName from '../../../components/item-variant/item-name' */
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
/* import VatLabel from '../../vat-label'
import ItemVariantProvider from '@salesforce/retail-react-app/app/components/item-variant' */
import {DeleteIcon, InfoIcon} from '../../icons'
import {FormattedMessage, useIntl} from 'react-intl'
/* import {remCalc} from '../../../theme/_utils' */
/* import {InformativeLabelGroup} from '../../informative-label'
import {productUrlBuilder} from '../../../utils/url'
import {useBooleanCustomPreference} from '../../../hooks/use-custom-preference' */
import InformativeLabel from '../../informative-label/partials/InformativeLabel'
import ProductPrice from '../../product-price/ProductPrice'
import BundleProductRow from './bundle-product-row'

const CartBundle = ({bundleItems, bundleDetails, bundleProduct, handleRemoveItem}) => {
    const {currency: activeCurrency} = useCurrency()
    const style = useStyleConfig('Bundle')
    const {formatMessage} = useIntl()
    /*     const isVATFlag = useBooleanCustomPreference('showVATFlag') */
    /*     const rawDiscount = bundleDetails?.discountPercentage || '0%' */
    /*     const numericDiscount = Math.round(parseFloat(rawDiscount.replace('%', ''))) */
    /*     const promoLabel = `${formatMessage({
        id: 'item_variant.discountLabel',
        defaultMessage: 'Discount',
    })} ${numericDiscount}%` */
    const bundlePriceData = {
        isOnSale: bundleDetails?.totalDiscountedPrice < bundleDetails?.totalPrice,
        listPrice: bundleDetails?.totalPrice,
        currentPrice: bundleDetails?.totalDiscountedPrice,
        isASet: false,
        isMaster: false,
        isRange: false,
    }
    const isFlexibleBundle = bundleDetails?.bundleType === 'Flexible'
    const productSetId = bundleItems?.find((item) => item?.c_productSetID)?.c_productSetID
    const bundleUrl = productSetId
        ? productUrlBuilder({...bundleProduct, productId: productSetId})
        : undefined
    const bundleImage = (
        <Image
            src={bundleDetails?.bundleImage}
            alt={bundleDetails?.bundleName}
            {...style.cartBundleImage}
        />
    )
    const bundleLabel = `${formatMessage({
        id: 'bundle.bundleLabel',
        defaultMessage: 'Bundle',
    })}`
    const primaryBundleItems = isFlexibleBundle
        ? bundleItems?.filter((item) => !item?.c_isBundleOptionalProduct)
        : bundleItems

    const optionalBundleItems = isFlexibleBundle
        ? bundleItems?.filter((item) => item?.c_isBundleOptionalProduct)
        : []

    const optionalBundleItemsCount = optionalBundleItems?.reduce(
        (sum, item) => sum + Number(item?.quantity || 0),
        0,
    )
    /*     const bundleWeeefee = bundleItems?.reduce((sum, product) => {
        const weeeFeeTotal =
            product?.priceAdjustments?.reduce((acc, adj) => {
                return adj?.promotionId === 'weeeFee' ? acc + (adj.price || 0) : acc
            }, 0) || 0
        return sum + weeeFeeTotal
    }, 0)

    const hasNoDiscount =
        Number(bundleDetails?.totalPrice) === Number(bundleDetails?.totalDiscountedPrice)

    const removeWeeeFeeFromPriceAfterItemDiscount = (product) => {
        if (!product?.priceAfterItemDiscount) return product?.price

        const weeeFeeTotal =
            product?.priceAdjustments?.reduce((sum, adj) => {
                return adj?.promotionId === 'weeeFee' ? sum + (adj.price || 0) : sum
            }, 0) || 0

        return product.priceAfterItemDiscount - weeeFeeTotal
    } */
    return (
        <Flex {...style.cartBundleContainer}>
            {bundleUrl ? (
                <Link to={bundleUrl} flexShrink={0}>
                    {bundleImage}
                </Link>
            ) : (
                bundleImage
            )}
            <Flex {...style.cartBundleContent}>
                <Flex {...style.cartHeaderContainer} justifyContent="space-between">
                    {/* USE THE RIGHT ICON INSTEAD OF INFOICON AND UNDERSTAND WHAT TO DO FOR DELETE BUTTON*/}
                    <InformativeLabel
                        label={bundleLabel}
                        variant="bundle"
                        icon={<InfoIcon boxSize="12px" width="12px" height="12px" />}
                    />
                </Flex>
                <Flex {...style.cartTitleContainer}>
                    <Flex {...style.cartBundleNameContainer}>
                        {bundleUrl ? (
                            <Link to={bundleUrl}>
                                <Text {...style.cartBundleName}>{bundleDetails?.bundleName}</Text>
                            </Link>
                        ) : (
                            <Text {...style.cartBundleName}>{bundleDetails?.bundleName}</Text>
                        )}
                    </Flex>
                    <Flex {...style.cartBundlePriceContainer}>
                        <Flex {...style.cartBundlePriceRow}>
                            <ProductPrice
                                priceData={bundlePriceData}
                                currency={activeCurrency}
                                variant="cart-product-item"
                            />
                            {/*
                            <Text data-testid="price">
                                <FormattedNumber
                                    style="currency"
                                    currency={activeCurrency}
                                    value={bundleDetails?.totalDiscountedPrice - bundleWeeefee}
                                />
                            </Text>

                            {!hasNoDiscount && (
                                <>
                                    <Text {...style.cartSuggestedPrice}>
                                        <FormattedNumber
                                            style="currency"
                                            currency={activeCurrency}
                                            value={bundleDetails?.totalPrice}
                                        />
                                    </Text>

                                    <InformativeLabel label={promoLabel} variant="light" />
                                </>
                            )} */}
                        </Flex>
                    </Flex>
                </Flex>

                <Button
                    onClick={handleRemoveItem}
                    data-testid="cart-item-remove-button"
                    className="js-personalization-remove-button"
                    variant="outline-not-rounded"
                    size="large"
                    data-product-code={bundleItems.map((product) => product.productId).join(',')}
                >
                    <DeleteIcon
                        w="16px"
                        h="16px"
                        data-product-code={bundleItems
                            .map((product) => product.productId)
                            .join(',')}
                    />
                </Button>

                <Flex {...style.cartProductSection}>
                    <Text {...style.cartProductSectionTitle}>
                        <FormattedMessage
                            id="cart.bundle.inThisBundle"
                            defaultMessage="In this bundle"
                        />
                    </Text>
                    <Flex {...style.cartProductSectionContainer}>
                        {primaryBundleItems?.map((product, idx) => (
                            <BundleProductRow
                                key={product?.itemId || idx}
                                product={product}
                                showQuantity={true}
                                quantity={product?.quantity || 1}
                            />
                        ))}
                    </Flex>
                </Flex>
                {isFlexibleBundle && optionalBundleItems?.length > 0 && (
                    <Flex {...style.cartProductSection}>
                        <Text {...style.cartProductSectionTitle}>
                            <FormattedMessage
                                id="cart.bundle.accessoriesAdded"
                                defaultMessage="Your accessories {count} added"
                                values={{count: optionalBundleItemsCount}}
                            />
                        </Text>

                        <Flex {...style.cartProductSectionContainer}>
                            {optionalBundleItems.map((product, idx) => (
                                <BundleProductRow
                                    key={product?.itemId || idx}
                                    product={product}
                                    showQuantity={true}
                                    quantity={product?.quantity || 1}
                                />
                            ))}
                        </Flex>
                    </Flex>
                )}
            </Flex>
        </Flex>
    )

    /* return (
        <Box {...style.cartBundleContainer}>
            <Flex {...style.cartHeaderContainer}>
                <Flex {...style.cartHeaderInfoContainer}>
                    <Text {...style.cartBundleName}>{bundleDetails?.bundleName}</Text>
                    <Flex {...style.cartHeaderPriceContainer}>
                        <Text data-testid="price">
                            <FormattedNumber
                                style="currency"
                                currency={activeCurrency}
                                value={bundleDetails?.totalDiscountedPrice - bundleWeeefee}
                            />
                        </Text>
                        {!hasNoDiscount && (
                            <>
                                <Text {...style.cartSuggestedPrice}>
                                    <FormattedNumber
                                        style="currency"
                                        currency={activeCurrency}
                                        value={bundleDetails?.totalPrice}
                                    />
                                </Text>
                                <InformativeLabel label={promoLabel} variant="light" />
                            </>
                        )}
                    </Flex>
                </Flex>
                <Button
                    onClick={handleRemoveItem}
                    data-testid="cart-item-remove-button"
                    className="js-personalization-remove-button"
                    data-product-code={bundleItems.map((product) => product.productId).join(',')}
                >
                    <DeleteIcon
                        w="16px"
                        h="16px"
                        data-product-code={bundleItems
                            .map((product) => product.productId)
                            .join(',')}
                    />
                </Button>
            </Flex>

            {bundleItems.map((product, idx) => {
                const cartItemPriceData = {
                    isOnSale: product.priceAfterItemDiscount < product.price,
                    listPrice: product.price,
                    unitPrice: product.priceAfterItemDiscount,
                }
                const productUrl = productUrlBuilder(product)
                return (
                    <ItemVariantProvider variant={product} key={idx}>
                        <Flex {...style.cartBundleItemContainer}>
                            <Link to={productUrl}>
                                <CartItemVariantImage
                                    {...style.cartBundleItemImage}
                                    imageProps={style?.cartImage}
                                />
                            </Link>
                            <Box {...style.cartItemDetailContainer}>
                                <Flex {...style.infoLabelContainer}>
                                    <InformativeLabelGroup
                                        product={product}
                                        priceData={cartItemPriceData}
                                        isBundle={true}
                                    />
                                </Flex>
                                <Box {...style.cartItemHeaderStack}>
                                    <Link to={productUrl}>
                                        <CartItemVariantName {...style.cartItemName} />
                                    </Link>
                                </Box>
                                {cartItemPriceData.unitPrice === 0 ? (
                                    <Box {...style.bundleFreeGiftLabel}>
                                        <FormattedMessage
                                            defaultMessage="Free Gift"
                                            id="bundle_free_gift.text"
                                        />
                                    </Box>
                                ) : (
                                    <Box {...style.cartItemOmniAndPrice}>
                                        <Text>
                                            <FormattedNumber
                                                style="currency"
                                                currency={activeCurrency}
                                                value={removeWeeeFeeFromPriceAfterItemDiscount(
                                                    product,
                                                )}
                                            />
                                        </Text>
                                        {cartItemPriceData.isOnSale && (
                                            <Flex gap={remCalc(8)}>
                                                <Text {...style.cartSuggestedPrice}>
                                                    <FormattedNumber
                                                        style="currency"
                                                        currency={activeCurrency}
                                                        value={product.price}
                                                    />
                                                </Text>
                                                <Text
                                                    {...style.cartSuggestedText}
                                                    color="success.100"
                                                >
                                                    {formatMessage({
                                                        id: 'item_variant.suggested_price',
                                                        defaultMessage: 'Suggested Price',
                                                    })}
                                                </Text>
                                            </Flex>
                                        )}
                                    </Box>
                                )}

                                {isVATFlag && (
                                    <Box {...style.cartItemVatDetails}>
                                        <HStack>
                                            <VatLabel
                                                price={product?.price}
                                                vatRate={product?.c_taxRate}
                                            />
                                        </HStack>
                                    </Box>
                                )}
                            </Box>
                        </Flex>
                    </ItemVariantProvider>
                )
            })}
        </Box>
    ) */
}

CartBundle.propTypes = {
    bundleItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    bundleProduct: PropTypes.object,
    bundleDetails: PropTypes.shape({
        totalPrice: PropTypes.number,
        totalDiscountedPrice: PropTypes.number,
        discountPercentage: PropTypes.string,
        bundleName: PropTypes.string,
        bundleImage: PropTypes.string,
        bundleType: PropTypes.string,
    }),
    handleRemoveItem: PropTypes.func,
}

export default CartBundle
